import { render } from "./Footer.vue?vue&type=template&id=e7eb81d4&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=e7eb81d4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/prd-cce-chain-browser-static-nft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7eb81d4"]])

export default __exports__